import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class AllModulesStateModel extends SubentityStateModel {
    filters = {
        list: [],
    };
    totalCount: number;
    sortBy: string;
    sortOrder: SortDirection;
    pageSize: number;
    pageNumber: number;

    allExecutionsSortBy: string;
    allExecutionsSortOrder: SortDirection;

    constructor() {
        super();

        this.sortBy = sessionStorage.getItem('allModulesSortBy');
        this.sortOrder = sessionStorage.getItem('allModulesSortOrder') as SortDirection;

        this.allExecutionsSortBy = sessionStorage.getItem('allExecutionsSortBy');
        this.allExecutionsSortOrder = sessionStorage.getItem('allExecutionsSortOrder') as SortDirection;
    }
}
